// @ts-nocheck
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import ValueCell from './ValueCell';
import { EMPTY_OBJECT } from '../../../../const/CommonConst';

/**
 * Cell renderer for the Value column
 * @param {Object} props - Cell props from React Table
 * @param {Object} props.row - The row data
 * @param {any} props.value - The cell value
 * @param {Function} handleEditClick - Function to handle edit click
 * @param {boolean} editPermission - Whether user can edit
 * @param {boolean} isMultipleEditMode - Whether in multiple edit mode
 * @param {Object} entityDetailsFormikForm - Formik form object
 * @param {Array} usersList - List of users
 * @param {Array} teamUsersList - List of team users
 * @param {Array} groupList - List of groups
 * @param {Object} entityData - Entity data
 * @param {Function} handleChange - Stable change handler function
 * @param {Object} attributeSourceMapping - Mapping of attribute sources
 * @param {boolean} loading - Whether data is loading
 * @returns {React.ReactElement} The rendered cell
 */
const ValueCellRenderer = (
  props,
  handleEditClick,
  editPermission,
  isMultipleEditMode,
  entityDetailsFormikForm,
  usersList,
  teamUsersList,
  groupList,
  entityData,
  handleChange,
  attributeSourceMapping,
  loading,
  isTableView = true,
  isDerived,
  isUserAuthorizedToOverrideAttribute,
  overrideData,
  handleOpenDerivedModal,
  handleAutoSave,
  // Constraint-related props
  lookupSourceAttributes,
  autoCompleteSourceAttributes,
  overrideDropdownOptions,
  isLoadingConstraints,
  dateCalendarConstraints,
  dateCalendarSourceAttributes,
  hasDraftChanges,
  groupDetails,
  mandatoryConstraints,
  hideAttributeInfo = false,
  modelTemplateDetails = EMPTY_OBJECT
) => {
  const { row, value } = props;

  const onEdit = useCallback(() => {
    handleEditClick(row.original);
  }, [handleEditClick, row.original]);

  return (
    <ValueCell
      row={row}
      value={value}
      onEdit={onEdit}
      editPermission={editPermission}
      isMultipleEditMode={isMultipleEditMode}
      hasDraftChanges={hasDraftChanges}
      entityDetailsFormikForm={entityDetailsFormikForm}
      usersList={usersList}
      teamUsersList={teamUsersList}
      groupList={groupList}
      entityData={entityData}
      handleChange={handleChange}
      attributeSourceMapping={attributeSourceMapping}
      loading={loading}
      isTableView={isTableView}
      isDerived={isDerived}
      isUserAuthorizedToOverrideAttribute={isUserAuthorizedToOverrideAttribute}
      overrideData={overrideData}
      handleOpenDerivedModal={handleOpenDerivedModal}
      handleAutoSave={handleAutoSave}
      // Constraint-related props
      lookupSourceAttributes={lookupSourceAttributes}
      autoCompleteSourceAttributes={autoCompleteSourceAttributes}
      overrideDropdownOptions={overrideDropdownOptions}
      isLoadingConstraints={isLoadingConstraints}
      dateCalendarConstraints={dateCalendarConstraints}
      groupDetails={groupDetails}
      mandatoryConstraints={mandatoryConstraints}
      hideAttributeInfo={hideAttributeInfo}
      dateCalendarSourceAttributes={dateCalendarSourceAttributes}
      modelTemplateDetails={modelTemplateDetails}
    />
  );
};

ValueCellRenderer.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      data_type: PropTypes.string,
      input_control_type: PropTypes.string,
    }),
  }),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ValueCellRenderer;
